
















































import Vue from 'vue';
import { path } from 'ramda';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import Loader from './Loader.vue';

extend('email', {
  ...email,
  message: 'The provided email is not valid',
});

extend('required', {
  ...required,
  message: 'The email is required',
});

interface NotifyMeFormState {
  email: string;
}

export default Vue.extend({
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    apiErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    apiError(): string | undefined {
      return path(['errors', '0'], this.apiErrors);
    },
    emailError(): string | undefined {
      return path(['email', '0'], this.apiErrors);
    },
  },
  data(): NotifyMeFormState {
    return { email: '' };
  },
  methods: {
    submit(): void {
      this.$emit('notify', this.email);
    },
  },
});

